import * as React from "react";
const SvgFiRrTrainStationBuilding = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-train-station-building_svg__a)">
      <path
        fill="#062147"
        d="m23.392 9.478-1.306-1.306A4.02 4.02 0 0 0 19.258 7h-2.26a5.01 5.01 0 0 0-1.637-3.7 5 5 0 0 0-1.991-1.106c-.12-.035-.247-.046-.37-.072V1a1 1 0 1 0-2 0v1.122c-.125.026-.256.037-.378.073A4.99 4.99 0 0 0 7 6.999H4.74a4.02 4.02 0 0 0-2.828 1.172L.606 9.477A2.048 2.048 0 0 0 1 12.692V20.5C1 22.43 2.57 24 4.5 24h.715A2.79 2.79 0 0 0 8 21.215V21c0-1.2.532-2.326 1.459-3.089.94-.775 2.13-1.072 3.357-.831C14.66 17.44 16 19.179 16 21.215A2.79 2.79 0 0 0 18.785 24h.715c1.93 0 3.5-1.57 3.5-3.5v-7.809a2.047 2.047 0 0 0 .392-3.213m-20.065.108A2 2 0 0 1 4.74 9H8a1 1 0 0 0 1-1V6.999a3 3 0 1 1 5.998.002V8a1 1 0 0 0 1 1h3.26a2 2 0 0 1 1.414.586l1.306 1.306-.045.108H2.064l-.044-.108zM19.5 22h-.715a.786.786 0 0 1-.785-.785c0-2.99-2.02-5.555-4.801-6.098a6.02 6.02 0 0 0-5.012 1.25A5.98 5.98 0 0 0 6 21v.215a.786.786 0 0 1-.785.785H4.5c-.827 0-1.5-.673-1.5-1.5V13h18v7.5c0 .827-.673 1.5-1.5 1.5m-9-15a1.5 1.5 0 1 1 3 .001 1.5 1.5 0 0 1-3-.001"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-train-station-building_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTrainStationBuilding;
